import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './GenericDialog.html?raw';

class GenericDialog extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    callback: any = function () { };
    destroyOnClose = true;
    buttoncount = 0;
    _standbyTargetNodeName = "modalDlg";
    closeOnEnter = true;

    _onClick_Close(){
        this.close(0);
    }
    _onClick_Button_Cancel(evt: any) {
        this.close(0);
    }
    _onClick_Button_OK(evt: any) {
        this.close(1);
    }

    _onClick_Button_YES(evt: any) {
        this.close(2);
    }

    _onClick_Button_NO(evt: any) {
        this.close(-1);
    }

    _onClick_Button_Close(evt: any) {
        this.close(0);
    }

    _onClick_Button_NEXT(evt: any) {
        this.close(3);
    }

    _onClick_Button_BACK(evt: any) {
        this.close(4);
    }

    _setCallbackAttr(value: any){
        this.callback = value;
    }

    _onKeyUp_Dlg(evt: any){ // Esc?
        if (evt.keyCode == 13 && this.closeOnEnter === true) {
            this.close(1);
        }
        if (evt.keyCode == 27) {
            this.close(0);
        }
    }

    hideSubtitleNode(bHide: any) {
        if (typeof (bHide) == "undefined") {
            bHide = true;
        }

        if (bHide === true) {
            domClass.add(this.subTitleNode, "w3-hide");
        } else {
            domClass.remove(this.subTitleNode, "w3-hide");
        }
    }

    _setHeaderAttr(value: any) {
        domAttr.set(this.headerNode, "innerHTML", value);
    }

    _setSubTitleAttr(value: any) {
        domAttr.set(this.subTitleNode, "innerHTML", value);
        domClass.remove(this.subTitleNode, "w3-hide");
    }

    _getHeaderAttr() {
        return domAttr.get(this.headerNode, "innerHTML");
    }

    _getSubTitleAttr() {
        return domAttr.get(this.subTitleNode, "innerHTML");
    }

     _setContentAttr(value: any){
         domAttr.set(this.textNode, "innerHTML", value);
    }

    _getContentAttr(){
        return domAttr.get(this.textNode, "innerHTML");
    }

    addNodeToContent(node: any, pos: any) {
        if (typeof (pos) == "undefined") pos = "last";
        domConstruct.place(node, this.textNode, pos);
    }

    addNodeToSubtitle(node: any, pos: any) {
        if (typeof (pos) == "undefined") pos = "last";
        domConstruct.place(node, this.subTitleNode, pos);

        domClass.remove(this.subTitleNode, "w3-hide");
    }

    // JS2TS: the original re-declared `_setHeaderAttr` here with an identical body; a TS class cannot
    // have duplicate members, so the duplicate is collapsed onto the first definition above. 1:1 behaviour.

    // JS2TS: the original re-declared `_getHeaderAttr` here with an identical body; collapsed onto the
    // first definition above (identical body). 1:1 behaviour.

    _setTopCloseBtnAttr(value: any){
        if( value === true){
            domStyle.set(this.topCloseBtn, "display", "block" );
        }else{
            domStyle.set(this.topCloseBtn, "display", "none" );
        }
    }

    showActionContainer(bool?: any) {
        //console.log("showActionContainer", this.buttoncount);
        if (this.buttoncount < 0) {
            this.buttoncount = 0;
        }

        if( typeof(bool) == "undefined")
        {
            bool = this.buttoncount > 0;
        }

        if( bool == true ) {
            domClass.remove(this.actionContainer, "w3-hide");
        }

        else {
            domClass.add(this.actionContainer, "w3-hide");
        }
    }

    open(){
        this.show();
    }

    Open() {
        this.show();
    }

    Show() {
        this.show();
    }

    show(){
        domStyle.set(this.modalDlg, "display", "block");
        this.emit("shown", this);
    }

    Close(){
        this.close();
    }

    hide() {
        this.close();
    }

    Hide() {
        this.close();
    }

    close(result?: any){
        domStyle.set(this.modalDlg, "display", "none");

        if (typeof (result) == "undefined") {
            result = 0;
        }

        //  callback-function nahezu in echtzeit aufrufen. aber asynchron ...
        //
        this.emit("close", result);
        setTimeout(lang.partial(this.callback, result ), 1);

        if (this.destroyOnClose === true) {
            //  selbstzerstörung in 1 Sekunde :-)
            //
            setTimeout(lang.hitch(this, "destroy"), 1000);
        }
    }

    _setYesAttr(value: any) {
        if (value === true) {
            domStyle.set(this.btn_yes, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_yes, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setNoAttr(value: any) {
        if (value === true) {
            domStyle.set(this.btn_no, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_no, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setOkAttr(value: any) {
        if (value === true) {
            domStyle.set(this.btn_ok, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_ok, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setCloseAttr(value: any) { // alias
        this.set("CloseBtn", value);
    }

    _setCloseBtnAttr(value: any) {
        if (value === true) {
            domStyle.set(this.btn_close, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_close, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setCancelAttr(value: any) {
        if (value === true) {
            domStyle.set(this.btn_cancel, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_cancel, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setBackAttr(value: any) {
        if (value === true) {
            domStyle.set(this.btn_back, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_back, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setNextAttr(value: any) {
        if (value === true) {
            domStyle.set(this.btn_next, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_next, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.buttoncount = 0;
        this.placeAt(document.body);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
}
GenericDialog.prototype.declaredClass = 'more.GenericDialog';

export default mdsWidget(GenericDialog);
